import React from 'react';
import { Modal, ModalProps } from '@mui/material';

/**
 * A custom Modal that only renders when open is true.
 */
const BaseModal: React.FC<ModalProps> = ({ open, children, ...rest }) => {
  if (!open) return null;

  return (
    <Modal open={open} {...rest}>
      {children}
    </Modal>
  );
};

export default BaseModal;
